import i18n from '@/portal/i18n'

export const requiredWithMessage = {
  required: i18n.t('validations.required'),

  validate: (value?: string) =>
    value && !value.trim().length ? i18n.t('validations.required') : undefined,
}
